export default {
  educationItem: {
    school: null,
    qualification: null,
    field_of_study: null,
    start_year: null,
    start_month: null,
    end_year: null,
    end_month: null,
    notes: null
  },
  educationList: [],
  educationErrorItem: {
    school: null,
    qualification: null,
    field_of_study: null,
    start_year: null,
    start_month: null,
    end_year: null,
    end_month: null,
    notes: null
  },
  educationErrorList: []
};
